var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare03 = function SvgShare03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20.5607",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 7.72472H16.6654V16.0581H3.33203V7.72472H6.66536",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 11.0607V1.89399M6.66797 4.39399L10.0013 1.06066L13.3346 4.39399",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
};
export default SvgShare03;